let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3kqC6")).then(() => parcelRequire('ecqVI'));